var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('btn',{staticClass:"btn btn-primary w-100",attrs:{"type":"button","disabled":_vm.orderPending},on:{"click":_vm.setOrder}},[_vm._v("Zamawiam i płacę")])}
var staticRenderFns = []

export { render, staticRenderFns }